module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-Banner.4e8ae246.webp";